import {
  ResourceTableRowMui as ResourceTableRow,
  ResourceTableRowMuiProps as ResourceTableRowProps,
  extractWorkflowFromInstanceName,
} from '@spotify/confidence-core-react';
import { WorkflowInstanceListItemFragment } from '@spotify/confidence-graphql';

import { workflowInstanceRouteRef } from '../../routes';

export const ROW_HEIGHT = 68;

export const WorkflowInstanceTableRow = ({
  workflowInstance,
  style,
  ...rest
}: Omit<ResourceTableRowProps, 'name' | 'routeRef' | 'params'> & {
  workflowInstance: WorkflowInstanceListItemFragment;
}) => {
  return (
    <ResourceTableRow
      routeRef={workflowInstanceRouteRef}
      name={workflowInstance.name}
      params={{
        workflow: extractWorkflowFromInstanceName(workflowInstance.name) || '',
      }}
      style={{ height: ROW_HEIGHT, ...style }}
      {...rest}
    />
  );
};
